import { Button, Grid, Paper, Typography } from '@mui/material';
import Form, { Field } from 'mobx-react-form';
import { observer } from 'mobx-react-lite';
import { useCallback, useState } from 'react';
import { useRootStore } from 'stores/RootStore';
import { CommercialReimbursement } from 'types/underwriting/income-approach';
import CommercialReimbursementContainer from './CommercialReimbursement';
import ReimbursementEditModal from './edit-modal/ReimbursementEditModal';
import React from 'react';

type CommercialReimbursementsProps = {
  form: Form;
};

const CommercialReimbursements = observer(({ form }: CommercialReimbursementsProps) => {
  const { underwritingPageStore } = useRootStore();
  const { underwritingData } = underwritingPageStore;
  const rentRoll = underwritingData?.incomeApproach?.commercial?.rentRoll || [];

  const commercialReimbursementsField: Field = form.$('incomeApproach.commercial.reimbursements');
  const [reimbursementModalState, setReimbursementModalState] = useState({
    open: false,
    reimbursement: undefined,
  });

  const onAddReimbursementClick = useCallback(() => {
    setReimbursementModalState({
      open: true,
      reimbursement: undefined,
    });
  }, [setReimbursementModalState]);

  const onAddReimbursementModalSave = useCallback(
    (newReimbursement: CommercialReimbursement) => {
      commercialReimbursementsField.add([newReimbursement]);
      setReimbursementModalState({
        open: false,
        reimbursement: undefined,
      });
    },
    [commercialReimbursementsField, setReimbursementModalState]
  );

  const onAddReimbursementModalCancel = useCallback(() => {
    setReimbursementModalState({
      open: false,
      reimbursement: undefined,
    });
  }, [setReimbursementModalState]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h6">Commercial Reimbursements</Typography>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <Button variant="contained" disabled={!rentRoll.length} onClick={onAddReimbursementClick}>
              ADD REIMBURSEMENT
            </Button>
          </Grid>
          <Grid item xs={12}>
            {commercialReimbursementsField
              .map((field: Field) => field)
              .map((commercialReimbursementField) => {
                return (
                  <Paper key={commercialReimbursementField.value.key} sx={{ padding: 2, margin: 2 }}>
                    <CommercialReimbursementContainer
                      form={form}
                      reimbursementFieldPath={commercialReimbursementField.path!}
                    />
                  </Paper>
                );
              })}
          </Grid>
        </Grid>
        {reimbursementModalState.open && (
          <ReimbursementEditModal
            isCreateModal={true}
            onSave={onAddReimbursementModalSave}
            onCancel={onAddReimbursementModalCancel}
          />
        )}
      </Grid>
    </Grid>
  );
});

export default CommercialReimbursements;
